module.exports = __webpack_public_path__ + "static/pug-6f9fdfed73a156be5a14c26fb5cc9aa3.gif";